/** The red banner while an admin views as a user (03 §12.1), with "Stop". */
import { t } from '@tarock/i18n';
import { useLocation } from 'preact-iso';
import { api } from '../net/api';
import { authStore, probeAuth } from '../stores/auth';

/** Shown on every page during impersonation. */
export function ImpersonationBanner() {
  const user = authStore.user.value;
  const { route } = useLocation();
  if (!user?.impersonatedBy) {
    return null;
  }
  const stop = async () => {
    await api('/api/admin/impersonation/stop', { body: {} });
    await probeAuth();
    route('/admin/users');
  };
  return (
    <div class="impersonation-banner" role="status" data-testid="impersonation-banner">
      {t('impersonation.banner', { name: user.displayName })}{' '}
      <button type="button" class="btn small" onClick={stop}>
        {t('impersonation.stop')}
      </button>
    </div>
  );
}
